export class BuildingMaterialTags {
  public static readonly GenericMaterial = "Generic Material";
  public static readonly DoNotImport = "Do Not Import";
  public static readonly NotThemed = "Not Themed";
        
  public static readonly BrickWall = "Brick Wall";
  public static readonly BrickWall2 = "Brick Wall 2";
  public static readonly BrickWall3 = "Brick Wall 3";

  public static readonly BrickSoldier = "Brick Soldier";
  public static readonly BrickSoldier2 = "Brick Soldier 2";
  public static readonly BrickSoldier3 = "Brick Soldier 3";

  public static readonly PlasterboardWall = "Plasterboard Wall";
  public static readonly PlasterboardWall2 = "Plasterboard Wall 2";
  public static readonly PlasterboardWall3 = "Plasterboard Wall 3";

  public static readonly Cladding = "Cladding";
  public static readonly Cladding2 = "Cladding 2";
  public static readonly Cladding3 = "Cladding 3";
  public static readonly CladdingHorizontal = "Cladding Horizontal";
  public static readonly CladdingVertical = "Cladding Vertical";

  public static readonly BrickRender = "Brick Render";
  public static readonly BrickRender2 = "Brick Render 2";
  public static readonly BrickRender3 = "Brick Render 3";

  public static readonly WallTiles = "Wall Tiles";
  public static readonly WallTiles2 = "Wall Tiles 2";
  public static readonly WallTiles3 = "Wall Tiles 3";

  public static readonly Laminate = "Laminate";
};
